angular.module('impactx.search').component('ixTenderItem', {
        bindings: {
            tender: '<'
        },
        require: {
            listCtrl: '^^ixTenderList'
        },
        controller: 'TenderItemCtrl',
        controllerAs: 'itemCtrl',
        templateUrl: 'modules/search/templates/tender-item.html'
    }
);